import {SimplePopup} from "../libs/simplePopup";

export default context => {

    const popup = new SimplePopup({content: ''})
    $('.user-connection-wrapper .actions', context).each(function() {
        const $menu = $(this).find('menu').detach()
        $(this).on('click', function() {
            popup.setContent($menu)
            popup.show(this)
        })
    })
}
